<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" v-if="(jumlah_lokasi - data.length) == 0" />
                <pageaddheader :title="title" :title1="title1" :items="items"
                    v-if="(jumlah_lokasi - data.length) > 0" />
                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <!-- <div class="search-path">
                                    <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter"
                                        :class="{ setclose: filter }">
                                        <img src="../../../assets/img/icons/filter.svg" alt="img" />
                                        <span><img src="../../../assets/img/icons/closes.svg" alt="img" /></span>
                                    </a>
                                </div> -->
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="../../../assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <!-- /Filter -->
                        <div class="card mb-0" id="filter_inputs" :style="{
                            display: filter ? 'block' : 'none',
                        }">
                            
                        </div>
                        <!-- /Filter -->
                        <div class="table-responsive">
                            <a-table :columns="columns" :data-source="filteredData" @change="onChange">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname">
                                            {{ record.no }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'id'">
                                        <div class="productimgname">
                                            <span href="javascript:void(0);">{{ record.nama_lokasi }}</span>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'alamat'">
                                        <div class="productimgname" style="max-width: 500px; white-space: pre-line;">
                                            {{ record.alamat }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'umr'">
                                        <div class="productimgname" style="max-width: 500px; white-space: pre-line;">
                                            {{ rupiah(record.umr) }}
                                        </div>
                                    </template>
                                    <template v-else-if="column.key === 'action'">
                                        <router-link class="me-3" to="editlocation" @click="edit(record);">
                                            <img src="../../../assets/img/icons/edit.svg" alt="img" />
                                        </router-link>
                                        <a class="confirm-text" href="javascript:void(0);"
                                            @click="terminate(record.id); showModal('terminate');">
                                            <img src="../../../assets/img/icons/delete.svg" alt="img" />
                                        </a>
                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" @click="">
        Launch demo modal
    </button> -->

    <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Data</h5>
                    <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="delete2">
                    <div class="modal-body">
                        Are u sure want to delete this data?
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-secondary"
                            @click="hideModal2('terminate')">cancel</button>
                        <button type="submit" class="btn  btn-danger">Delete</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, rupiah } from "@/assets/js/function";
import { watch } from "vue";

export default {
    data() {
        return {
            filter: false,
            title: "Location List",
            title1: "Manage location",
            items: [
                {
                    text: "Add New Location",
                    addname: "/addlocation",
                },
            ],
           

            //data
            data: [
                {
                    id: 1,
                    no: 1,
                    kode_lokasi: "HO",
                    nama_lokasi: "HO",
                    latlng: "",
                    alamat: "",
                    radius: "",
                },

            ],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Location Name",
                    dataIndex: "nama_lokasi",
                    key: "id",
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_lokasi.toLowerCase();
                            b = b.nama_lokasi.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Address",
                    dataIndex: "alamat",
                    key: "alamat",
                    sorter: {
                        compare: (a, b) => {
                            a = a.alamat.toLowerCase();
                            b = b.alamat.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "UMR",
                    dataIndex: "umr",
                    key: "umr",
                    sorter: {
                        compare: (a, b) => {
                            a = a.umr.toLowerCase();
                            b = b.umr.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },

                {
                    title: "Action",
                    key: "action",
                    sorter: false,
                    fixed: 'right'
                },
            ],

            jumlah_lokasi: 0,

            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",

            //filter
            query: "",
        };
    },
    async created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        
        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')

        await this.index();
        // this.index_lokasi();
    },

    mounted() {

        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },

    computed: {
        filteredData() {
            // Filter data based on selected jenis_kehadiran
            if (this.query == '') {
                return this.data; // If no filter selected, return all data
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison

            return this.data.filter(item =>
                item.nama_lokasi.toLowerCase().includes(lowerCaseQuery) ||
                item.alamat.toLowerCase().includes(lowerCaseQuery)
            );
        }
    },
    methods: {

        rupiah,
        
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },

        formatDateLocaly(dateInput) {
            const dateObj = new Date(dateInput);
            if (isNaN(dateObj.getTime())) return null; // Invalid date check

            const year = dateObj.getFullYear();
            const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
            const day = ('0' + dateObj.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        },

        async index() {
           
            let formData = new FormData();
            appendForm(formData)

            //  for (let [key, value] of formData.entries()) {
            //     console.log(key, value);
            // }
            // CloseLoading(); return;
          

            const api = base_url + '/v3/location/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const location = data.data.data_lokasi
            // console.log('ini response', data);

            if(data.status){
                this.data = [];
                location.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });

                this.jumlah_lokasi = parseInt(data.data.jumlah_lokasi);
               
                
                return;
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

           

        },

        // async index_lokasi() {
           
        //     const formData = new FormData();
        //     appendForm(formData)
        //     const currentDate = new Date();

        //     var dateObj = new Date(currentDate);

        //     // Format the date manually (e.g., yyyy-mm-dd)
        //     var year = dateObj.getFullYear();
        //     var month = ('0' + (dateObj.getMonth() + 1)).slice(-2); // Add leading zero for single digits
        //     var day = ('0' + dateObj.getDate()).slice(-2); // Add leading zero for single digits

        //     var formattedDate = `${year}-${month}-${day}`;

        //     formData.append('periode', formattedDate);



        //     if (process.env.NODE_ENV === "development") {
        //         this.api = base_url + 'dashboard_index';
        //     } else {
        //         this.api = base_url + 'dashboard_index';
        //     }
        //     axios
        //         .post(this.api, '', this.config)
        //         .then((response) => {
        //             if (response.data.status == true) {
        //                 this.jumlah_lokasi = response.data.data.jumlah_lokasi;
        //                 CloseLoading();
        //             }


        //             if (response.data.status == false) {
        //                 AlertPopup("error", "", response.data.message, 1500, false);
        //             }
        //         })
        //         .catch((error) => {
        //             ErrorConnectionTimeOut(error);
        //         });

        // },
        
        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
        },
        async delete2() {
           
            let formData = new FormData();
            appendForm(formData)

            formData.append("id", this.id_terminate);
            
            
            // for (let [key, value] of formData.entries()) {
            //   console.log(`${key}: ${value}`);
            // }

            const api = base_url + '/v3/location/delete';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
           
            if(data.status){
                const index = this.data.findIndex((record) => record.id === this.id_terminate);
                        this.data.splice(index, 1);
                        AlertBottom(data.message);
                        this.hideModal2('terminate');
               
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

            


        },
        terminate(id) {
            this.id_terminate = id;
            this.tanggal_terminate = new Date();
        }
    },
    name: "productlist",
};
</script>
<style>
.ant-tooltip {
    display: none !important;
}
</style>